module.exports = __webpack_public_path__ + "img/opendental-patient-search.25a8adc4.png";